import React, { useEffect, useState } from 'react';

import { Box, Slide, Typography, useMediaQuery } from '@mui/material';

import {
  IStyles,
  NoContentCard,
  deserify,
  getLocalStorage,
  pxToRem,
  pxTovW,
  theme,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import {
  Banner,
  BannerV2,
} from '@protos/learning_management/lms.teacher.apis_pb';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSelectedClassInfo } from '../../Analytics/reducer/analytics.slice';
import { interactionEvent } from '../../Auth/auth.events';
import { useGlobalContext } from '../../../app/Context/GlobalContextProvider';
import { display } from '@mui/system';
import { useDownloadContext } from '../../../app/Context/DownloadContextProviderV2';
import { useAppSelector } from '../../../reduxStore/reduxHooks';
import { setTeacherBanner } from '../reducer/homeDashboard.slice';
import { SnapShotBanner } from './SnapshotBanner';
import { BannerShimmer } from './BannerShimmer';

const styles: IStyles = {
  root: {
    p: { xs: pxToRem(0), md: pxTovW(0) },
    cursor: 'pointer',
  },

  dotContainer: {
    display: 'flex',
    gap: { md: pxTovW(7) },
    justifyContent: 'center',
    mt: { md: pxTovW(10) },
  },
  dots: {
    width: { xs: pxTovW(12) },
    height: { xs: pxTovW(12) },
    borderRadius: '50%',
    cursor: 'pointer',
  },
};

export const TeacherHomeWebCarousel = () => {
  const { isOffline } = useDownloadContext();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const { isIpadOnly } = useGlobalContext();
  // const [banners, setBanners] = useState<Banner[]>([]);
  const [totalDots, setTotalDots] = useState(0);
  const [currentDot, setCurrentDot] = useState(0);
  const teacher_id = deserify(getLocalStorage('userId'));
  const [currentSet, setCurrentSet] = useState<BannerV2[] | undefined>([]);
  const { teacher_banner } = useAppSelector((state) => state.homeDashboard);
  const { LmsTeacherAPIServiceV2ClientWithStatusCodeHandler } =
    useCommonServiceClientContext();

  // useEffect(() => {
  //   if (teacher_banner) {
  //     processTeacherBanner(teacher_banner);
  //   }
  // }, [teacher_banner]);

  // const processTeacherBanner = (banners: BannerV2[]) => {
  //   const first3: BannerV2[] = [];
  //   banners.forEach((elem, index) => {
  //     if (index < 3) first3.push(elem);
  //   });

  //   setCurrentSet(first3);
  //   setTotalDots(Math.ceil(banners.length / 3));
  // };

  // function getElementsSet(number: number) {
  //   const startIndex = number * 3;
  //   const endIndex = startIndex + 3;
  //   const set = teacher_banner?.slice(startIndex, endIndex);

  //   if (number === 3 && set && set.length < 3) {
  //     return teacher_banner?.slice(teacher_banner.length - 3);
  //   }

  //   return set;
  // }

  // const [dragStartX, setDragStartX] = useState<number | null>(null);

  // const handleDragStart = (event: React.DragEvent<HTMLDivElement>) => {
  //   setDragStartX(event.clientX);
  // };

  // const handleDragEnd = (event: React.DragEvent<HTMLDivElement>) => {
  //   const dragEndX = event.clientX;
  //   const deltaX = dragEndX - dragStartX!;

  //   if (deltaX > 0) {
  //     // Call your function for dragging right here
  //     if (currentDot > 0 && teacher_banner) {
  //       setCurrentDot(currentDot - 1);
  //       setCurrentSet(getElementsSet(currentDot - 1));
  //     }
  //   } else if (deltaX < 0) {
  //     // Call your function for dragging left here
  //     if (currentDot < totalDots - 1) {
  //       // console.log('currentDot:', currentDot);
  //       setCurrentDot(currentDot + 1);
  //       setCurrentSet(getElementsSet(currentDot + 1));
  //     }
  //   }
  // };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = React.useRef(null);
  const totalPages = Math.ceil((teacher_banner?.length ?? 0) / 3);

  useEffect(() => {
    fetchBanners(); // Fetch banners if needed
  }, []);

  const fetchBanners = async () => {
    try {
      setLoading(true);
      const response =
        await LmsTeacherAPIServiceV2ClientWithStatusCodeHandler.fetchTeacherBanners(
          {
            teacherId: teacher_id,
          }
        );
      if (response.banners) {
        dispatch(setTeacherBanner(response.banners));
        // setBanners(response.banners);
      } else {
        dispatch(setTeacherBanner([]));
      }
      // console.log(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(true);
      dispatch(setTeacherBanner(undefined));
    }
  };

  const handleDotClick = (pageIndex: number) => {
    setCurrentIndex(pageIndex * 3);
  };
  return loading === true ? (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        overflowX: { xs: 'auto', md: 'unset' },
        '&::-webkit-scrollbar': {
          display: { xs: 'none', md: 'initial' },
        },
        gap: { xs: pxToRem(20), md: pxTovW(30), lg: pxTovW(30) },
      }}
    >
      {ActiveBannerArray?.map((item, index) => (
        <React.Fragment key={index}>{item}</React.Fragment>
      ))}
    </Box>
  ) : error === true ? (
    <Box
      width={{ xs: undefined, md: '100%' }}
      marginBottom={{ xs: pxToRem(20), md: pxTovW(40) }}
    >
      <NoContentCard variant="error" icon="error" text="Error Occured" />
    </Box>
  ) : teacher_banner && teacher_banner.length === 0 ? (
    <NoContentCard variant="info" icon="cards" text="No Data to show" />
  ) : (
    <Box
      // draggable={true}
      // onDragStart={handleDragStart}
      // onDragEnd={handleDragEnd}
      onClick={async () => {
        await interactionEvent({
          url: 'Teacher_Home',
          context: 'performance_snapshot',
          name: 'PERFORMANCE_SNAPSHOT_OPEN',
          isOffline: isOffline,
        });
      }}
      sx={styles.root}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          overflowX: { xs: 'auto', md: 'auto' },
          '&::-webkit-scrollbar': {
            display: { xs: 'none', md: 'none' },
          },
          gap: { xs: pxToRem(20), md: pxTovW(30), lg: pxTovW(25) },
          padding: { md: pxTovW(10) },
        }}
        ref={containerRef}
      >
        {teacher_banner &&
          teacher_banner.map((elem, index) => {
            const isVisible = index >= currentIndex && index < currentIndex + 3;
            return (
              <Slide
                key={index}
                direction={isVisible ? 'left' : 'right'}
                in={isMobile ? true : isVisible}
                mountOnEnter
                unmountOnExit
                container={containerRef.current}
              >
                <div>
                  <SnapShotBanner
                    banner={elem}
                    key={index}
                    onClick={() => {
                      dispatch(
                        setSelectedClassInfo({
                          classname: `${elem.class}`,
                          section: elem.section,
                          sectionId: elem.sectionId,
                          subject: elem.subject,
                          subjectId: elem.subjectId,
                        })
                      );
                      navigate('/analytics-classScore');
                    }}
                  />
                </div>
              </Slide>
            );
          })}
      </Box>
      {/* <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: pxTovW(48) }}>
        {currentSet &&
          currentSet.map((elem, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
              onClick={() => {
                dispatch(
                  setSelectedClassInfo({
                    classname: `${elem.class}`,
                    section: elem.section,
                    sectionId: elem.sectionId,
                    subject: elem.subject,
                    subjectId: elem.subjectId,
                  })
                );
                navigate('/analytics-classScore');
              }}
            >
              <ImageWrapper
                name="PerformanceBanner"
                type="png"
                // path={elem.imageUrl}
                // parentFolder="tempAssets"
                styles={{
                  boxShadow: `0 0 ${pxTovW(10)} grey`,
                  width: isIpadOnly ? pxTovW(500) : pxTovW(446),
                  height: isIpadOnly ? pxTovW(250) : pxTovW(215),
                  objectFit: 'fill',
                  position: 'fit',
                  borderRadius: pxTovW(30),
                  // boxShadow: `0px 0px ${pxTovW(10)} #E7E7E7D9`,
                }}
              />
              <Box
                style={{
                  display: isIpadOnly ? 'flex' : 'block',
                  flexDirection: 'column',
                  position: 'absolute',

                  top: pxTovW(45),
                  bottom: 0,
                  left: pxTovW(30),
                  width: '40%',
                }}
              >
                <Typography
                  variant={isIpadOnly ? 'h5' : 'h2'}
                  fontWeight="900"
                  color={'success.main'}
                >
                  {Math.round(elem.scorePercent)}%
                </Typography>
                <Typography
                  variant={isIpadOnly ? 'smallText' : 'h3'}
                  fontWeight="700"
                  color={'success.main'}
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  in {elem.subject}
                </Typography>
                <Typography
                  variant={isIpadOnly ? 'smallText' : 'h3'}
                  fontWeight="bold"
                >
                  Scored By{' '}
                </Typography>
                <Typography
                  variant={isIpadOnly ? 'smallText' : 'h3'}
                  fontWeight="bold"
                >
                  {elem.class}
                  {elem.section} Class
                </Typography>
              </Box>
            </Box>
          ))}
      </Box> */}
      {!isMobile && teacher_banner && teacher_banner.length > 3 ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mt: { xs: pxToRem(12), md: pxTovW(18) },
            gap: pxToRem(8),
          }}
        >
          {Array.from({ length: totalPages }).map((_, pageIndex) => (
            <Box
              key={pageIndex}
              onClick={() => handleDotClick(pageIndex)}
              sx={{
                width: pxToRem(10),
                height: pxToRem(10),
                borderRadius: '50%',
                backgroundColor:
                  currentIndex / 3 === pageIndex ? '#F8C807' : '#FEEDAE',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
              }}
            />
          ))}
        </Box>
      ) : (
        <></>
      )}
      {/* <Box sx={styles.dotContainer}>
        {Array.from({ length: totalDots || 0 }).map((elem, index) => (
          <Box
            key={index}
            onClick={() => {
              setCurrentDot(index);
              setCurrentSet(getElementsSet(index));
            }}
            sx={{
              ...styles.dots,
              bgcolor:
                index === currentDot ? 'warning.main' : 'hsl(46, 100%, 82%)',
            }}
          ></Box>
        ))}
      </Box> */}
    </Box>
  );
};

const ActiveBannerArray = [
  <BannerShimmer />,
  <BannerShimmer />,
  <BannerShimmer />,
];
